<template >
  <boxDropDown title="Configurar Cargo duplo">
    <template class="support-tools">

      <div class="form-group col-md-6">
        <label for="companyIdToAddAccountant">ID da empresa</label>
        <input type="text" class="form-control" v-model="dataSend.companyId" placeholder="ID da empresa" id="companyIdToAddAccountant">
      </div>

      <div class="form-group col-md-6">
        <label for="employeeIdToDualRole">ID do colaborador</label>
        <input type="text" class="form-control" v-model="dataSend.companyId" placeholder="ID do colaborador" id="employeeIdToDualRole">
      </div>

      <div class="form-group col-md-6">
        <label for="roleOne">ID do cargo 1</label>
        <input type="text" class="form-control" v-model="dataSend.roleOne" placeholder="Cargo 1" id="roleOne">
      </div>

      <div class="form-group col-md-6">
        <label for="roleTwo">ID do cargo 2</label>
        <input type="text" class="form-control" v-model="dataSend.roleTwo" placeholder="Cargo 2" id="roleTwo">
      </div>

      <div class="send-data-tools form-group col-md-12">
        <button class="btn btn-primary" @click="sendData()">
          <span v-if="true">Concluir alteração</span>
          <span v-else class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </span>
        </button>
        <span class="send-data-tools__validate">{{ messageValidateFields }}</span>
      </div>
    </template>
  </boxDropDown>
</template>

<script>
  import boxDropDown from "../../../components/layouts/boxDropDown.vue";

  export default {
    name: "configure-dual-role",
    components: {
      boxDropDown,
    },
    data() {
      return {
        messageValidateFields: "",
        dataSend: {
          companyId: "",
          employeeId: "",
          roleOne: "",
          roleTwo: ""
        },
        contentSetting: ""
      }
    },
    methods: {
      validateFields() {
        if (!this.dataSend.companyId) {
          this.messageValidateFields = "Preencha o campo de ID da empresa";
          return false;
        } else {
          if (this.dataSend.companyId.length === 32) {
            this.messageValidateFields = "ID da empresa inválido";
            return false;
          }
        }

        if (!this.dataSend.employeeId) {
          this.messageValidateFields = "Preencha o campo de ID do colaborador";
          return false;
        }

        if (!this.dataSend.roleOne) {
          this.messageValidateFields = "Preencha o campo de Função 1";
          return false;
        }

        if (!this.dataSend.roleTwo) {
          this.messageValidateFields = "Preencha o campo de Função 2";
          return false;
        }

        this.messageValidateFields = "";
        return true;
      },
      sendData() {
        if (!this.validateFields()) {
          return;
        }

        console.log(this.dataSend);
      }
    }
  }
</script>

<style lang="scss" scoped>
  * {
    font-family: "Montserrat", sans-serif !important;
  }

  .support-tools {
    &__warning {
      padding: 10px;
      text-align: center;
      background-color: #FFDF8D;
      border-radius: 8px !important;
      color: #FF445D;
    }
  }

  .send-data-tools {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    gap: 15px;

    &__validate {
      color: #ed6b75;
    }
  }

  .btn-primary {
    margin: 0 !important;
  }

  .full-width{
    width: 100% !important;
  }

  .spacing-bottom{
    margin-bottom: 8px;
  }

  .company-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #F0F0F0;
    padding: 10px 10px 10px 20px;
    margin-bottom: 15px;

    &__title {
      font-weight: bold;
      color: #201E1E;
    }

    &__close {
      height: 16px;
      width: 16px;
      font-size: 16px;
      color: #E74A4E;
      cursor: pointer;
    }
  }

  .center{
    margin: auto;
  }

  .input-with-date {
    width: 100%;

    input {
      width: 100%;
    }
  }

</style>


// WEBPACK FOOTER //
// src/vue/pages/restricted/support/supportItems/configureDualRole.vue